/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.buttongroup[_ngcontent-%COMP%], .mat-table[_ngcontent-%COMP%], .smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-top:15px}.smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-bottom:10px}.padding[_ngcontent-%COMP%]{padding:20px}.actionbar[_ngcontent-%COMP%]{margin-top:15px}.displaylist[_ngcontent-%COMP%]{min-width:350px}.padding-top[_ngcontent-%COMP%]{padding-top:10px}.padding-bottom[_ngcontent-%COMP%]{padding-bottom:10px}.margin-bottom[_ngcontent-%COMP%]{margin-bottom:20px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/issuealert/issuealert.component.css.shim.ngstyle.js.pre-build-optimizer.js